import { useCallback, useEffect, useState } from "react";
import { useDispatchApp } from "../../../lib/redux";
import { startGetAdvertiserKpiSummary } from "../../../actions/user";

const useGlobalReportKpiSummary = (advertiserID) => {
  const dispatch = useDispatchApp();
  const [kpiSummary, setKpiSummary] = useState(null);
  const [isLoadingKpiSummary, setIsLoadingKpiSummary] = useState(false);

  const fetchKpiSummary = useCallback(async () => {
    if (!advertiserID) {
      setKpiSummary(null);
      return;
    }

    setIsLoadingKpiSummary(true);
    try {
      const response = await dispatch(
        startGetAdvertiserKpiSummary({ advertiserID })
      );
      setKpiSummary(response?.ok ? (response.kpiSummary ?? null) : null);
    } finally {
      setIsLoadingKpiSummary(false);
    }
  }, [advertiserID, dispatch]);

  useEffect(() => {
    fetchKpiSummary();
  }, [fetchKpiSummary]);

  const onKpiSummarySaved = useCallback(({ kpiSummary: next }) => {
    setKpiSummary(next ?? null);
  }, []);

  return {
    kpiSummary,
    isLoadingKpiSummary,
    reloadKpiSummary: fetchKpiSummary,
    onKpiSummarySaved,
  };
};

export default useGlobalReportKpiSummary;
